import { useSelector } from 'react-redux';
import * as React from 'react';

import { TgbNativedescGeneral } from './TgbNativedescGeneral';
import { getCurrentJsonQuery } from '../../../selectors/location';
import { TgbNativedescGeneralContext } from '../../../types/adfox';

type TgbNativedescGeneralContainerProps = {
  context: TgbNativedescGeneralContext;
};

export const TgbNativedescGeneralContainer: React.FC<TgbNativedescGeneralContainerProps> = props => {
  const { context } = props;

  const jsonQuery = useSelector(getCurrentJsonQuery);
  const locationId = jsonQuery.region?.value[0];

  return <TgbNativedescGeneral context={context} locationId={locationId} />;
};
